module.exports = __webpack_public_path__ + "static/media/15.9f3d0044.jpg";